import { useRef, useState, useEffect } from "react";
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL;

const UseNotAcceptOrderTripAvailable = () => {
  const navigate = useNavigate();
  const { authFetch } = useAuth();

  const [loadingCancelOrderTripAvailable, setLoadingCancelOrderTripAvailable] =
    useState(false);

  const cancelOrderTripAvailable = async (serie, type, payload = {}) => {
    try {
      setLoadingCancelOrderTripAvailable(true);

      if (!serie) {
        throw new Error("Negociação inválida.");
      }

      console.log(serie);
      return;

      const response = await authFetch(
        `${API_URL}/api/trip-negotiations/${serie}/cancel-order/`,
        {
          method: "POST",
          headers: {
            //Authorization: `Bearer ${accessToken}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            cancel_as: type,
          }),
        },
      );

      const data = await response.json();

      if (!response.ok && response.status !== 202) {
        throw new Error(data?.detail || "Erro ao efetuar pagamento.");
      }

      console.log(data);
      //return;

      setLoadingCancelOrderTripAvailable(false);
      navigate(`/${data.notification_redirect}`, {
        state: {
          item: null,
          notification_type: data.notification_type,
          from: "notification",
        },
      });
    } catch (err) {
      setLoadingCancelOrderTripAvailable(false);
    }
  };

  return {
    loadingCancelOrderTripAvailable,
    cancelOrderTripAvailable,
  };
};

export default UseNotAcceptOrderTripAvailable;
